import "jquery";
import _ from "lodash";
import "./special_news_registry.scss";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/js/fontawesome";
import "@fortawesome/fontawesome-free/js/solid";
import "@fortawesome/fontawesome-free/js/regular";
import "@fortawesome/fontawesome-free/js/brands";
import page_template from "../../layouts/page-template";
import page_header from "../header/header";
import page_footer from "../footer/footer";
import coffee_main from "../coffee.main";
import sponsors from "../sponsors";
import form_banner_img from "../../assets/banners/1_BannerDescargaelApp.png";
import "../coffee.main.scss";
import logo from "../../assets/logos/01_LNBPLogo.svg";

const page_template_content = document.getElementById(
  "js__page_template_content"
);
const page_template_header_title = document.getElementById(
  "js__page_template_header_title"
);
const base_url = coffee_main.base_url;
const id_season = coffee_main.id_season;
const page_title = "Registra tu visita";

//set page template and loader
page_template.setPageTemplate();

//size menu items on sidebar
page_header.setPageTemplate();

//content for page
//page title
coffee_main.createSectionTitle(page_title, page_template_header_title);

/**** main content start ****/

//small banner
let container = document.createElement("div");
container.classList.add("row", "col", "justify-content-center");

let form_container = document.createElement("div");
form_container.classList.add(
  "col-lg-4",
  "col-md-4",
  "col-sm-12",
  "justify-content-center"
);

//place de banner
let form_banner = document.createElement("img");
form_banner.src = form_banner_img;
form_banner.classList.add("form_banner");

form_container.appendChild(form_banner);

//place de form
let form_title = document.createElement("h6");
form_title.innerText = "Registra tu visita";

let dot = document.createElement("div");
dot.classList.add("dot");

let lnbp_logo = document.createElement("img");
lnbp_logo.src = logo;
lnbp_logo.classList.add("form_logo");

let form_inputs = document.createElement("div");
form_inputs.classList.add("col-lg-5", "col-md-5", "col-sm-12", "form_inputs");

form_inputs.appendChild(lnbp_logo);
form_inputs.appendChild(dot);
form_inputs.appendChild(form_title);

let compound_name_row = document.createElement("div");
compound_name_row.classList.add("row");

let compound_name = document.createElement("div");
compound_name.classList.add("col-sm-12", "col-md-6", "col-lg-6");

let compound_last_name = document.createElement("div");
compound_last_name.classList.add("col-sm-12", "col-md-6", "col-lg-6");

compound_name.appendChild(
  coffee_main.createTextInput(
    "Nombre",
    "Nombre",
    "first_name",
    "text",
    "first_name",
    true,
    "",
    true,
    ["me-1"]
  )
);

compound_last_name.appendChild(
  coffee_main.createTextInput(
    "Apellidos",
    "Apellidos",
    "last_name",
    "text",
    "last_name",
    true,
    "",
    true
  )
);

compound_name_row.appendChild(compound_name);
compound_name_row.appendChild(compound_last_name);

form_inputs.appendChild(compound_name_row);

form_inputs.appendChild(
  coffee_main.createTextInput(
    "Correo Electrónico",
    "Correo Electrónico",
    "email",
    "text",
    "email",
    true,
    "",
    true
  )
);
form_inputs.appendChild(
  coffee_main.createTextInput(
    "Teléfono",
    "Teléfono",
    "phone",
    "text",
    "phone",
    true,
    "",
    true
  )
);
form_inputs.appendChild(
  coffee_main.createTextInput(
    "Ciudad",
    "Ciudad",
    "city",
    "text",
    "city",
    true,
    "",
    true
  )
);
form_inputs.appendChild(
  coffee_main.createTextInput(
    "Estado",
    "Estado",
    "state",
    "text",
    "state",
    true,
    "",
    true
  )
);

let accept_terms = document.createElement("div");
accept_terms.classList.add("row", "pt-2");

let accept_terms_checkbox_container = document.createElement("div");
accept_terms_checkbox_container.classList.add(
  "form-check",
  "col-lg-6",
  "col-md-6"
);
let accept_terms_checkbox_check = document.createElement("input");
accept_terms_checkbox_check.classList.add("form-check-input");
accept_terms_checkbox_check.type = "checkbox";
accept_terms_checkbox_check.value = 0;
accept_terms_checkbox_check.id = "js__accept_terms_checkbox_check";

let accept_terms_checkbox_label = document.createElement("label");
accept_terms_checkbox_label.classList.add("form-check-label");
accept_terms_checkbox_label.setAttribute(
  "for",
  "js__accept_terms_checkbox_check"
);
accept_terms_checkbox_label.style.fontSize = "0.8rem";
accept_terms_checkbox_label.id = "js__newsletter_label";
accept_terms_checkbox_label.innerHTML =
  "<sup>*</sup> Acepto los términos, condiciones y politicas de privacidad de la LNBP.";

accept_terms_checkbox_container.appendChild(accept_terms_checkbox_check);
accept_terms_checkbox_container.appendChild(accept_terms_checkbox_label);

let submit_btn = document.createElement("input");
submit_btn.type = "button";
submit_btn.id = "js__submit_btn";
submit_btn.value = "Enviar";
submit_btn.classList.add("col-lg-6", "col-md-6", "submit_btn");

accept_terms.appendChild(accept_terms_checkbox_container);
accept_terms.appendChild(submit_btn);
form_inputs.appendChild(accept_terms);
container.appendChild(form_container);
container.appendChild(form_inputs);

page_template_content.appendChild(container);

submit_btn.addEventListener("click", () => {
  let name = document.getElementById("first_name");
  let last_name = document.getElementById("last_name");
  let email = document.getElementById("email");
  let phone = document.getElementById("phone");
  let city = document.getElementById("city");
  let state = document.getElementById("state");
  let regisry_checkbox = document.getElementById(
    "js__accept_terms_checkbox_check"
  );

  if (name.value == "") {
    name.classList.add("news_letter_require");
  } else {
    name.classList.remove("news_letter_require");
  }
  if (last_name.value == "") {
    last_name.classList.add("news_letter_require");
  } else {
    last_name.classList.remove("news_letter_require");
  }
  if (email.value == "") {
    email.classList.add("news_letter_require");
  } else {
    email.classList.remove("news_letter_require");
  }
  if (phone.value == "") {
    phone.classList.add("news_letter_require");
  } else {
    phone.classList.remove("news_letter_require");
  }
  if (city.value == "") {
    city.classList.add("news_letter_require");
  } else {
    city.classList.remove("news_letter_require");
  }
  if (state.value == "") {
    state.classList.add("news_letter_require");
  } else {
    state.classList.remove("news_letter_require");
  }
  if (regisry_checkbox.checked == false) {
    document.getElementById("js__newsletter_label").innerHTML =
      "<sup>*</sup> Acepto los términos, condiciones y politicas de privacidad de la LNBP.<span style='color:red'> Requerido</span>";
  } else {
    document.getElementById("js__newsletter_label").innerHTML =
      "<sup>*</sup> Acepto los términos, condiciones y politicas de privacidad de la LNBP.";
  }

  if (
    name.value != "" &&
    last_name.value != "" &&
    email.value != "" &&
    phone.value != "" &&
    city.value != "" &&
    state.value != "" &&
    regisry_checkbox.checked != false
  ) {
    $.ajax({
      type: "POST",
      url: base_url + "/profile/users/newsletterbasic",
      data: {
        name: name.value,
        last_name: last_name.value,
        phone_number: phone.value,
        email: email.value,
        city: city.value,
        state: state.value,
        newsletter: 0
      }
    }).done(function (response) {
      name.value = "";
      last_name.value = "";
      email.value = "";
      phone.value = "";
      city.value = "";
      state.value = "";
      regisry_checkbox.checked = false;
      document.getElementById("js__submit_btn").value =
        "¡Gracias por registrarte!";
    });
  }
});

//small banner
page_template_content.appendChild(displayTopBanner(base_url, 33));

//sponsors
sponsors.displaySponsors(page_template_content);

/**** main content end ****/

//page_footer
page_footer.render(base_url, id_season);

//hide loader at the end, always at the bottom of this index file
$(window).on("load", function () {
  page_template.hideLoader();
});

//********* page functions start ******/

/* Banner */
function displayTopBanner(base_url, id_entry) {
  //Prepare the request data.
  var ajax_data = {
    id: id_entry
  };

  let image_container = document.createElement("div");
  image_container.classList.add("text-center", "banner_center");

  $.ajax({
    type: "POST",
    url: base_url + "/cms/entries/single",
    data: ajax_data
  }).done(function (response) {
    let image = document.createElement("img");
    image.src = base_url + response.item.full_url_image;
    if (
      response.item.full_url_image != null &&
      !response.item.full_url_image.includes("no-image.jpg")
    ) {
      image_container.appendChild(image);
    }
  });

  return image_container;
}
